<template>
<fragment>
    <div id="wrap" :class="wrapClass === 'SDC' ? 'landing_wrap' : ''">
        <skp-gnb :ref="gnbId" v-if="isRouterAlive" @router-reload="routerReload()"></skp-gnb>
        <!-- Contents -->
        <router-view
            v-if="isRouterAlive"
            :key="$route.fullPath"
            @changeWrapClass="changeWrapClass"
        ></router-view>
        <!-- FOOTER -->
        <keep-alive>
            <!-- 
            <skp-footer v-if="!isASC && isRouterAlive" @router-reload="routerReload()"/>
            <asc-footer v-else-if="isASC && isRouterAlive" @router-reload="routerReload()"/>
            -->
            <skp-footer v-if="isRouterAlive" @router-reload="routerReload()"/>
        <!-- //FOOTER -->
        </keep-alive>
        <keep-alive>
            <recommend-pop />
        </keep-alive>
    </div>
    <div class="goto_top"><a href="javascript:" class="scroll_top_btn"><span class="sr_only">TOP</span></a></div>
</fragment>
</template>
<script>
import Vue                          from 'vue';
import { mapActions, mapGetters }   from 'vuex';
import $                            from 'jquery';
import axios                        from 'axios';
import store                        from '@/vuex/store';
import { SDLUtil }                  from '@/utils';
import { EventBus }                 from '@/utils/EventBus';

import SKPGnb                       from './SKPGnb';
import SKPFooter                    from './SKPFooter';
import ASCFooter                    from './ASCFooter';
import RecommendPopup               from '~vb/common/RecommendPopup';

export default {
    name: 'SKPMain',
    components : {
        'skp-gnb'       : SKPGnb,
        'skp-footer'    : SKPFooter,
        'asc-footer'    : ASCFooter,
        'recommend-pop' : RecommendPopup
    },
    data() {
        return {
            isRouterAlive: true,
            wrapClass: 'SKP',
            isASC: false,
            gnbId: 'SKPGnb'
        }
    },
    computed: {
        ...mapGetters({
            deptLevelCd: 'getDeptLevelCd',
        }),
    },
    methods: {
        routerReload() {
            Vue.$log.info('▶ SKPMain.vue routerReload.');
            this.isRouterAlive = false;
            setTimeout(() => {
                this.isRouterAlive = true;
                EventBus.$emit('gnb-menu-event-reload');
            });
        },
        changeWrapClass(v) {
            // Samsung.com Page 사용. created 시 SDC / beforeDestroy 시 SKP 로 변경한다.
            if(!SDLUtil.isNull(v)) this.wrapClass = v;
        },
        btnGotoTop() {
            $(window).scroll(function() {
                if ($(this).scrollTop() > 200) {
                    $('.goto_top').fadeIn();
                } else {
                    $('.goto_top').fadeOut();
                }
            });

            $(".scroll_top_btn").click(function() {
                $('html, body').animate({
                    scrollTop : 0
                }, 400);
                return false;
            });
        }
    },
    beforeCreate() {
        const r = this.$router.history.current.query.r || '';
        if (r) {
            this.$router.replace(r);
        }
    },
    created() {
        if(Number(this.deptLevelCd) === 1) this.isASC = true;
        EventBus.$on('router-reload', () => { this.routerReload(); });
        if ($('body').hasClass('admin_wrap') === true) 
            $('body').removeClass('admin_wrap');
    },
    mounted() {
        this.btnGotoTop();
        // ASC 권한 = deptLevelCode 가 1 일 경우
        if(this.isASC) {
            let body = document.getElementsByTagName('body')[0];
            if(!body.classList.contains('asc_wrap')) body.classList.add('asc_wrap');
        };
    },
    beforeDestroy() {
        EventBus.$off('router-reload');
    }
};
</script>
<style scoped></style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/main/SKPMain.vue